// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import Checkbox from "@store/MobiusOverrides/Checkbox/Checkbox";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";

enum fields {
    label = "label",
    dataKey = "dataKey",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.dataKey]: string;
    };
}

type Props = OwnProps;

const ContactUsCheckBox: React.FC<Props> = ({ fields }) => {
    const { label, dataKey } = fields;
    const value = useSelector((state: ApplicationState) => state.components.contactUsForm.fieldValues[dataKey]);
    const dispatch = useAppDispatch();
    const handleChange = (value: boolean) => {
        const valueAsString = value ? "true" : "false";
        dispatch(setFieldValue({ key: dataKey, value: valueAsString }));
    };

    return (
        <Checkbox
            css={css`
                margin: ${pxToRem(15)} 0;
                display: flex;
                align-items: center;
                > label {
                    margin-top: 4px;
                }
            `}
            checked={getBooleanProperty(value)}
            onChange={(_, value) => handleChange(value)}
        >
            {label}
        </Checkbox>
    );
};

const widgetModule: WidgetModule = {
    component: ContactUsCheckBox,
    definition: {
        group: "Contact Us",
        icon: "Checkbox",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Subscribe to Newsletter",
                isRequired: true,
            },
            {
                name: fields.dataKey,
                displayName: "Data Key",
                editorTemplate: "TextField",
                fieldType: "General",
                defaultValue: "subscribeToNewsletter",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
